<template>
  <div class="main-container">
    <div class="page-title">
      <img src="~img/logo/vb100.png" alt="">
      <p>小程序券码核销系统</p>
    </div>
    <div class="main-btn">
      <div class="code" @click="themeModal = true">
        <img src="~img/logo/sao.png" alt="">
        <p>扫码核销</p>
      </div>
      <div class="records" @click="goToRecords">
        <img src="~img/logo/record.png" alt="">
        <p>核销记录</p>
      </div>
      <div class="logout" @click="loginOutModal = true">
        <img src="~img/logo/out.png" alt="" >
        <p>退出登录</p>
      </div>
    </div>
    <Modal class="message-modal" width="580" v-model="loginOutModal" title="提示" @on-ok="exitLogin" :scrollable="true">
      <p class="tip-font">是否确定退出登录</p>
    </Modal>
    <Modal class="message-modal" width="580" v-model="themeModal" title="选择论坛" :footer-hide="true" @on-visible-change="resetModal" :scrollable="true">
      <div class="theme-modal">
        <div :class="['select-item', validStatus == 1 && 'error']">
          <div class="select-title">活动</div>
          <Select v-model="currentActivityId" @on-change="selectActivity">
            <Option v-for="item in activityDtoList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
          <div class="error-info">请选择活动</div>
        </div>
        <div :class="['select-item', validStatus == 2 && 'error']" v-if="currentActivityItem.type == 2">
          <div class="select-title">论坛</div>
          <Select v-model="currentSubActivityId" @on-change="selectSub">
            <Option v-for="item in subList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
          <div class="error-info">请选择论坛</div>
        </div>
      </div>
      <div class="modal-footer">
        <Button @click="themeModal = false">取消</Button>
        <Button type="primary" @click="cancelCode">开始核销</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { exitLogin, mainActivitylist, subActivitylist } from '@/service/main.js'
export default {
  components: {},
  computed: {},
  data() {
    return {
      loginOutModal: false,
      themeModal: false,
      activityDtoList: [],
      currentActivityId: '',
      currentActivityItem: {},
      subList: [],
      currentSubActivityId: '',
      currentSubActivityItem: {},
      validStatus: 0,
    }
  },
  created() {
    this.mainActivitylist()
  },
  methods: {
    cancelCode() {
      this.validStatus = 0
      if (!this.currentActivityItem.id) {
        this.validStatus = 1
        return
      }
      if (this.currentActivityItem.type == 2 && !this.currentSubActivityId) {
        this.validStatus = 2
        return
      }

      let currentId =
        this.currentActivityItem.type == 1 ? this.currentActivityId : this.currentSubActivityId
      let currentName = this.currentActivityItem.type == 1 ? this.currentActivityItem.name : this.currentSubActivityItem.name
      let currentPrintStatus = this.currentActivityItem.type == 1 ? this.currentActivityItem.printStatus : this.currentSubActivityItem.printStatus
      this.$router.push({ name: 'cancelCode', params: { id: currentId }, query: {printStatus: currentPrintStatus, name: currentName} })
    },
    goToRecords() {
      this.$router.push({ name: 'cancelRecords' })
    },
    async exitLogin() {
      let res = await exitLogin({ user_key: this.$store.state.userKey })
      if (res.code == 0) {
        this.$Message.success('退出登录成功！')
        this.$store.commit('removeUserKey')
        this.$router.push({ name: 'login' })
      } else {
        this.$Message.error(res.msg)
      }
    },
    async mainActivitylist() {
      let res = await mainActivitylist({})
      if (res.code == 0) {
        this.$set(this.$data, 'activityDtoList', res.data.activityDtoList)
      } else {
        this.$Message.error(res.msg)
      }
    },
    async subActivitylist(mainId) {
      let res = await subActivitylist({
        mainId,
      })
      if (res.code == 0) {
        this.$set(this.$data, 'subList', res.data)
      } else {
        this.$Message.error(res.msg)
      }
    },
    selectActivity(value) {
      this.validStatus = 0
      this.currentActivityItem = this.activityDtoList.find((a) => a.id == value) || {}
      if (this.currentActivityItem.type == 1) return
      if (value) this.subActivitylist(value)
    },
    selectSub(value) {
      this.validStatus = 0
      this.currentSubActivityItem = this.subList.find((a) => a.id == value) || {}
    },
    resetModal() {
      this.currentActivityId = ''
      this.currentActivityItem = {}
      this.currentSubActivityId = ''
      this.currentSubActivityItem = {}
      this.validStatus = 0
    },
  },
}
</script>
<style lang='stylus' scoped>
.message-modal
  >>>.ivu-modal-mask
    background-color rgba(0, 0, 0, 0.6)
  >>>.ivu-modal-wrap
    display flex
    align-items center
    justify-content center
  >>>.ivu-modal
    top auto
    .ivu-modal-content
      background #ffffff
      border-radius 0
    .ivu-modal-header-inner
      color #333
      font-size 30px
      height 36px
      line-height 36px
      text-align center
    .ivu-modal-close
      top 16px
      .ivu-icon-ios-close
        color #333
        font-size 38px
        &:hover
          color #2c66d2
    .ivu-modal-header
      border-bottom none
      padding 20px
    .ivu-modal-body
      padding 20px 50px
    .ivu-modal-footer, .modal-footer
      border-top none
      text-align center
      padding 20px 40px 40px
      button
        width 160px
        height 60px
        font-size 28px
        &+button
          margin-left 90px
        &.ivu-btn-primary
          border 0
          background linear-gradient(90deg, #2765F6, #6E99FC)
        &.ivu-btn-text, &.ivu-btn-default
          background #CCCCCC
          color #FFFFFF
          border 0
    .modal-footer
      padding 20px 0 40px
.tip-font
  font-size 18px
  color #333
  text-align center
.theme-modal
  min-height 200px
  .select-item
    position relative
    margin-bottom 40px
    .select-title
      position absolute
      height 16px
      font-size 16px
      color #333333
      line-height 1
      padding 0 6px
      background #fff
      z-index 2
      top -7px
      left 30px
    .error-info
      color #ff0000
      position absolute
      font-size 16px
      line-height 24px
      bottom -24px
      opacity 0
    &.error
      .error-info
        opacity 1
      >>> .ivu-select-selection
        border-color #ff0000
  >>> .ivu-select
    width 100%
    .ivu-select-selection
      border-color #CCC
      height 60px
      .ivu-select-placeholder, .ivu-select-selected-value
        height 58px
        line-height 58px
        font-size 18px
        padding-left 30px
        padding-right 40px
      .ivu-select-selected-value
        color #333
    .ivu-select-arrow
      font-size 18px
      color #333
    .ivu-select-item
      color #333
      padding 10px 20px
      font-size 18px !important
.main-container
  width 1200px
  height 100vh
  display flex
  flex-direction column
  justify-content center
  margin 0 auto
  position relative
  .page-title
    position absolute
    top 10vh
    img
      width 198px
      height 56px
    p
      font-size 34px
      font-weight 500
      line-height 1
      margin-top 10px
  .main-btn
    display flex
    width 100%
    justify-content space-between
    padding 0 100px
    > div
      width 140px
      text-align center
      font-size 0
      display flex
      flex-direction column
      justify-content space-between
      align-items center
      cursor pointer
      img
        width auto
        height auto
      p
        width 100%
        font-size 30px
        font-weight bold
        color #333333
        line-height 1
        margin-top 50px
</style>